import { isLoggedIn } from '@/utils/auth'
import { handleWeChatGuardAuth } from '@/utils/wechatSilentAuth'

const whiteList = [
  '/login',
  '/register',
  '/payment/unified/pay',
  '/payment/qrcode/innercode',
  '/payment/qrcode/lanecode',
  '/payment/qrcode/rs-record',
  '/h5/rsparking-record',
  '/h5/rsparking-merge',
  '/payment/confirm',
  '/payment/parking-details',
  '/payment/sub-orders',
  '/payment/success',
  '/parking/monthly-card/quick-renewal',
  '/redemption',
  '/transfer'
]

export { isLoggedIn as checkAuth }

export const setupGuards = (router) => {
  router.beforeEach(async (to, from, next) => {
    if (to.path === '/' && typeof window !== 'undefined' && window.location.hash) {
      const hash = window.location.hash
      if (hash.startsWith('#/')) {
        const fullPath = hash.slice(1)
        next(fullPath)
        return
      }
    }

    const isInWhiteList = whiteList.some(path => {
      const basePath = path.replace(/\/\*?$/, '')
      return to.path.startsWith(basePath)
    })

    const requiresNoAuth = to.matched.some(record => record.meta.noAuth)

    if (isInWhiteList || requiresNoAuth) {
      next()
      return
    }

    if (isLoggedIn()) {
      next()
      return
    }

    const wxResult = await handleWeChatGuardAuth(to.fullPath)
    if (wxResult === 'logged_in') {
      next({ ...to, replace: true })
      return
    }
    if (wxResult === 'oauth_redirect') {
      return
    }

    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  })
}
